import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { cloneDeep, isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../scss/table.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moFreshCity from './store';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import IndicatorTable from '../../indicator-table';
import Table from './table';
import Explain from './explain';
import ExplainPDF from './explain-pdf';
import FreshTable from '../../fresh-table';

interface IProps {}
interface IState {}

const TablePDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { tableHead, tableList } = moFreshCity;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      <Table tableHead={tableHead} tableList={tableList.slice(0, 25)} />
      {tableList.length > 25 ? (
        <Table tableHead={tableHead} tableList={tableList.slice(25)} />
      ) : null}
      {(tableList.length > 15 && tableList.length <= 25) ? <ExplainPDF /> : null}
    </>
  );
};

export default observer(TablePDF);
